var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4220_9939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4220_9939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.5H13.5V3.75C13.5 3.55109 13.421 3.36032 13.2803 3.21967C13.1397 3.07902 12.9489 3 12.75 3H11.25C11.0511 3 10.8603 3.07902 10.7197 3.21967C10.579 3.36032 10.5 3.55109 10.5 3.75V10.5H3.75C3.55109 10.5 3.36032 10.579 3.21967 10.7197C3.07902 10.8603 3 11.0511 3 11.25V12.75C3 12.9489 3.07902 13.1397 3.21967 13.2803C3.36032 13.421 3.55109 13.5 3.75 13.5H10.5V20.25C10.5 20.4489 10.579 20.6397 10.7197 20.7803C10.8603 20.921 11.0511 21 11.25 21H12.75C12.9489 21 13.1397 20.921 13.2803 20.7803C13.421 20.6397 13.5 20.4489 13.5 20.25V13.5H20.25C20.4489 13.5 20.6397 13.421 20.7803 13.2803C20.921 13.1397 21 12.9489 21 12.75V11.25C21 11.0511 20.921 10.8603 20.7803 10.7197C20.6397 10.579 20.4489 10.5 20.25 10.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5dcb87e16ab7b63e7c54737662b89a4f.svg";
export { ForwardRef as ReactComponent };